/**
 * A column the search matches by the words it shows, not by the field behind
 * them: a reader types "red", "failed" or "2d", never `true`, "failure" or an
 * ISO timestamp.
 */
export const searchesShown =
  <Row>(shown: (row: Row) => string) =>
  (term: string, row: Row) =>
    shown(row).toLowerCase().includes(term.toLowerCase());
